import React from "react";
import './WithdrawalPage.css';
import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import axios from 'axios';

import OfferHistory from './OfferHistory.js';
import OfferPayPalHistory from './OfferPayPalHistory.js';
import OfferPayeerHistory from './OfferPayeerHistory.js';
import BronzeOffer from "../Offers/BronzeOffer";
import SilverOffer from "../Offers/SilverOffer";
import GoldOffer from "../Offers/GoldOffer";

import BTC from "../../../img/WithdrawalPage/BTC.png";
import BCH from "../../../img/WithdrawalPage/BCH.png";
import ETH from "../../../img/WithdrawalPage/ETH.png";
import LTC from "../../../img/WithdrawalPage/LTC.png";
import USDT from "../../../img/WithdrawalPage/USDT.png";
import BNB from "../../../img/WithdrawalPage/bnb.png";
import BUSD from "../../../img/WithdrawalPage/busd.png";
import TRX from "../../../img/WithdrawalPage/trx.png";
import paypal from "../../../img/WithdrawalPage/paypal.png";
import payeer from "../../../img/WithdrawalPage/payeer.jpg";

import vindax from "../../../img/IndexMain/vindax.png";
import p2p from "../../../img/IndexMain/p2p.png";
import indoex from "../../../img/IndexMain/indoex.png";
import coinsbit from "../../../img/IndexMain/coinsbit.png";
import { marketLang } from "./marketLang";

class WithdrawalPage extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            clientID: 'fake', //real
            secretKey: 'fake', //real
            hostname: 'api.paypal.com',
            accessToken: null,
            captureID: false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        }
    }

    async componentDidMount(){
        let self = this;
        await axios.request({
            url: `https://${this.state.hostname}/v1/oauth2/token`,
            method: "post",
            headers:{
                Accept: "application/json",
                "Accept-Language": "en_US",
                "Content-Type": "application/x-www-form-urlencoded"
            },
            auth: {
              username: this.state.clientID,
              password: this.state.secretKey
            },
            params: {
                grant_type: 'client_credentials'
            }
        }).then(res => {
            self.setState({accessToken: res.data.access_token});

            let queryString = window.location.search.slice(1);
            let obj = {};
            if (queryString) {
            queryString = queryString.split('#')[0];
            let arr = queryString.split('&');
            for (let i=0; i<arr.length; i++) {
                let a = arr[i].split('=');
                let paramNum = undefined;
                let paramName = a[0].replace(/\[\d*\]/, function(v) {
                paramNum = v.slice(1,-1);
                return '';
                });
                let paramValue = typeof(a[1])==='undefined' ? true : a[1];
                paramName = paramName.toLowerCase();
                if (obj[paramName]) {
                if (typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                }
                if (typeof paramNum === 'undefined') {
                    obj[paramName].push(paramValue);
                }
                else {
                    obj[paramName][paramNum] = paramValue;
                }
                }
                else {
                obj[paramName] = paramValue;
                }
            }
            }

            if (obj.token) {
                axios.post(`https://${this.state.hostname}/v2/checkout/orders/${obj.token}/capture`,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${res.data.access_token}`,
                        'PayPal-Request-Id': 'default'
                    }
                }).then(res2 => {
                    if (res2.data.status == "COMPLETED") {
                        self.setState({captureID: true});
                    }                    
                });
            }
        });
    }

    render(){
        return (            
            <div className="WithdrawalPage">                
                <TopPafeInfo session={this.props.session} />
                
                <div className="PersonalPageMain StandartPartMain">
                    <div className="PersonalPageMainPersonalInformation StandartBigElement">
                        {/*
                        <div class="IndexMainElementIn">
                            <div class="StandartElementTitle">{marketLang.title[this.state.Language]}</div>
                            <div class="StandartElementTopBorder"></div>
                        </div>
                       
                        {this.state.captureID ? (
                            <div className="PaymentSuc">
                                Your PayPal payment was successful!<br/>
                                Enrollment will take place within an hour.
                            </div>
                        ) : (
                            <>
                            <div className="row">
                                <div class="col-md-4 col-sm-12">
                                    <BronzeOffer session={this.props.session} reload={true}/>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <SilverOffer session={this.props.session} reload={true}/>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <GoldOffer session={this.props.session} reload={true}/>
                                </div>
                            </div>
                            <div className="row mt20px">
                                <div className="col-md-12 text-center" style={{color: '#D8B168'}}>
                                    {marketLang.support[this.state.Language]} <a style={{color: '#D8B168'}} href="https://t.me/artyfactsupport" target="_blank">{marketLang.support2[this.state.Language]}</a>.
                                    <br/><br/>
                                </div>
                            </div>
                            <div className="row mt20px">
                                <div className="col-md-12 text-center only-white">
                                    {marketLang.accept[this.state.Language]}<br/>
                                    <img className="CoinAcceptImg ml5px" src={BTC} />
                                    <img className="CoinAcceptImg" src={ETH} />
                                    <img className="CoinAcceptImg" src={LTC} />
                                    <img className="CoinAcceptImg" src={USDT} />
                                    <img className="CoinAcceptImg" src={BNB} />
                                    <img className="CoinAcceptImg" src={BUSD} />
                                    {/*<img className="CoinAcceptImg2" src={paypal} />
                                    <img className="CoinAcceptImg2" src={payeer} />*/} {/*
                                </div>
                            </div>
                            </>
                        )} */}
                                                
                        <OfferHistory session={this.props.session} />
                        {/*<OfferPayPalHistory session={this.props.session} />    
                        <OfferPayeerHistory session={this.props.session} />*/}
                    </div>
                </div>
            </div>
        )}
    }

export default withAuth(session => session && session)(withRouter(WithdrawalPage));